"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var styles = __importStar(require("./TextArea.module.css"));
var TextArea = (function (_super) {
    __extends(TextArea, _super);
    function TextArea() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TextArea.prototype.render = function () {
        var _a = this.props, id = _a.id, json_data = _a.json_data, onChange = _a.onChange, rows = _a.rows, placeholder = _a.placeholder, disabled = _a.disabled, errors = _a.errors;
        var value = json_data[id] || "";
        var error = errors[id];
        var css = styles.root;
        if (error) {
            css = css + " " + styles.rootError;
        }
        return (React.createElement("div", null,
            React.createElement("textarea", { rows: rows, className: css, id: id, value: value, onChange: function (event) {
                    onChange(id, event.target.value);
                }, placeholder: placeholder, disabled: disabled }),
            error && React.createElement("p", { className: styles.error },
                error,
                " ")));
    };
    TextArea.defaultProps = {
        rows: 5,
        errors: {}
    };
    return TextArea;
}(react_1.Component));
exports.TextArea = TextArea;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVGV4dEFyZWEuanMiLCJzb3VyY2VSb290IjoiLi8iLCJzb3VyY2VzIjpbInBkZi9jb21wb25lbnRzL1RleHRBcmVhL1RleHRBcmVhLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsMkNBQThCO0FBQzlCLCtCQUErQjtBQUUvQiw0REFBK0M7QUFZL0M7SUFBOEIsNEJBQW9CO0lBQWxEOztJQWlDQSxDQUFDO0lBM0JVLHlCQUFNLEdBQWI7UUFDVSxJQUFBLGVBQTJFLEVBQTFFLFVBQUUsRUFBRSx3QkFBUyxFQUFFLHNCQUFRLEVBQUUsY0FBSSxFQUFFLDRCQUFXLEVBQUUsc0JBQVEsRUFBRSxrQkFBb0IsQ0FBQTtRQUNqRixJQUFNLEtBQUssR0FBRyxTQUFTLENBQUMsRUFBRSxDQUFDLElBQUksRUFBRSxDQUFBO1FBQ2pDLElBQU0sS0FBSyxHQUFHLE1BQU0sQ0FBQyxFQUFFLENBQUMsQ0FBQTtRQUV4QixJQUFJLEdBQUcsR0FBRyxNQUFNLENBQUMsSUFBSSxDQUFBO1FBQ3JCLElBQUksS0FBSyxFQUFFO1lBQ1AsR0FBRyxHQUFNLEdBQUcsU0FBSSxNQUFNLENBQUMsU0FBVyxDQUFBO1NBQ3JDO1FBRUQsT0FBTyxDQUNIO1lBQ0ksa0NBQ0ksSUFBSSxFQUFFLElBQUksRUFDVixTQUFTLEVBQUUsR0FBRyxFQUNkLEVBQUUsRUFBRSxFQUFFLEVBQ04sS0FBSyxFQUFFLEtBQUssRUFDWixRQUFRLEVBQUUsVUFBQyxLQUFLO29CQUNaLFFBQVEsQ0FBQyxFQUFFLEVBQUUsS0FBSyxDQUFDLE1BQU0sQ0FBQyxLQUFLLENBQUMsQ0FBQTtnQkFDcEMsQ0FBQyxFQUNELFdBQVcsRUFBRSxXQUFXLEVBQ3hCLFFBQVEsRUFBRSxRQUFRLEdBQ3BCO1lBQ0QsS0FBSyxJQUFJLDJCQUFHLFNBQVMsRUFBRSxNQUFNLENBQUMsS0FBSztnQkFBRyxLQUFLO29CQUFNLENBQ2hELENBQ1QsQ0FBQTtJQUNMLENBQUM7SUEvQmEscUJBQVksR0FBRztRQUN6QixJQUFJLEVBQUUsQ0FBQztRQUNQLE1BQU0sRUFBRSxFQUFFO0tBQ2IsQ0FBQTtJQTZCTCxlQUFDO0NBQUEsQUFqQ0QsQ0FBOEIsaUJBQVMsR0FpQ3RDO0FBakNZLDRCQUFRIn0=